<template>
  <div class="game">
    <hp-h-u-d v-if="stillOn" class="HUD"
        :hp="hp">
    </hp-h-u-d>
    <div class="progression" :class="[isMobile?'':'paddingRound SmallRoundAngles']"  >
      <div id="progressPendu" :class="!isMobile?'plainTheme':''" v-if="gameMode === 'survival'">
        <div class="lightplainTheme">{{currentWordNb}}</div>
        <div style="font-size: 0.7em; height: 100%; padding: 0.25vw;">{{wordsNb}}</div>
      </div>

      <div v-else @click="pickAgain()">
          <span>
          Mot suivant
          </span>
      </div>
    </div>
    <pendu-word class="penduWord" v-if="stillOn"
        :english="localWordsList[currentWordIndex].english"
        :french="localWordsList[currentWordIndex].french[0]"
                :definition="localWordsList[currentWordIndex].definition"
        :key="localWordsList[currentWordIndex].english"
        :automatic-display="autoDisplay"
        @hpLoss="substractHp"
        @hpGain="recoverHP"
        @wordGuessed="goNext">
    </pendu-word>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
// import {API_URL} from "@/App";
//import {lock} from "@/main";
//import axios from "axios";

export default {
  name: "penduSession",

  components: {
    penduWord: () => import(/* webpackPrefetch: true */ '@/components/penduWord.vue'),
    hpHUD: () => import(/* webpackPrefetch: true */ '@/components/hpHUD.vue')
  },

  props: {
    wordsList: Array,
    gameMode: String
  },

  created() {
    if(this.gameMode === 'tenWords') {
      this.localWordsList = this.wordsList.slice(0,10);
    }
    else if(this.gameMode === 'survival') {
      this.localWordsList = this.wordsList.slice();
    }
    this.wordsNb = this.localWordsList.length;
    this.pickAgain();
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'profile',
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
    ]),
    stillOn: function () {
      return (!this.victory && !this.gameOver)
    }
  },

  methods: {
    ...mapActions('game', [
        'set_gameOn'
    ]),

    setGameOver(){
      if(!this.$isDebug){
        gtag('event', 'PenduEnded', {
          'event_category': 'Game',
          'event_label': 'gameOver'
        })

        fbq('track', 'Pendu Ended');
        fbq('track', 'Pendu Game Over');
      }
      this.currentWordNb =  this.currentWordNb-1;
      this.gameOver = true;
      this.quitGame()
    },
    setVictory(){
      if(!this.$isDebug){
        gtag('event', 'PenduEnded', {
          'event_category': 'Game',
          'event_label': 'victory'
        })

        fbq('track', 'Pendu Ended');
        fbq('track', 'Pendu Victory');
      }
      this.victory = true;
      this.quitGame()
    },

    nbAlea(min, max) {
      let nb = -1;
      do{
        nb = Math.trunc((Math.random() * (max) + min));
      }
      while(nb === this.currentWordIndex)

      return nb;
    },

    pickAgain() {
      this.currentWordIndex = this.nbAlea(0, this.localWordsList.length)
      this.previousWordIndex = this.currentWordIndex;
    },

    goNext(value) {
      window.setTimeout(() => {
        this.recoverHP(value);
        if(this.localWordsList.length <=1) {
          this.setVictory()
        }
        else {
          this.pickNextWord();
        }
      }, 2500)

    },

    pickNextWord() {
      this.localWordsList.splice(this.previousWordIndex,1);
      if(this.localWordsList.length <= 1) {
        this.currentWordIndex = 0;
      }
      else {
        this.currentWordIndex = this.nbAlea(0, this.localWordsList.length);
      }

      this.previousWordIndex = this.currentWordIndex;
      this.currentWordNb++
    },

    substractHp(value) {
      this.hp = this.hp+value
      if(this.hp <= 0) {
        this.autoDisplay = true;
        window.setTimeout(() => {
          this.setGameOver()
          }, 2500)

      }
    },

    recoverHP(value) {
      if(this.hp + value >= 100) {
        this.hp = 100
      }
      else {
        this.hp = this.hp+value
      }
    },

    quitGame() {
      this.$emit('quit', this.currentWordNb)
    }
  },

  data() {
    return {
      localWordsList: [],
      currentWordIndex: 0,
      hp: 100,
      previousWordIndex: -1,
      currentWordNb: 1,
      autoDisplay: false,
      wordsNb: 0,
      victory: false,
      gameOver: false
    }
  }
}
</script>

<style scoped>
  .game {
    height: calc(100% - 1vw);
    width: calc(100% - 1vw);
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr auto;
    justify-items: center;
    padding: 0.5vw;
    overflow-y: auto;
  }

  .penduWord {
    grid-column: 1/3;
    grid-row: 2/3;
  }

  .HUD {
    grid-column: 1/2;
    grid-row: 1/2;
    justify-self: flex-start;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .progression {
    grid-column: 2/3;
    grid-row: 1/2;
  }

  .message {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
  }

  #progressPendu {
    text-align: center;
    flex-direction: column;
    height: 2.5vw;
    width: 2.5vw;
    border-radius: 2.5vw;
    font-weight: bold;
    z-index: 3;
    overflow: hidden;
  }

  @media screen and (max-device-width: 767px) {
    .game {
      height: calc(100% - 1vw);
      width: calc(100% - 1vw);
      display: grid;
      grid-template-rows: 1fr auto;
      grid-template-columns: 1fr auto;
      justify-items: center;
      padding: 0.5vw;
      overflow: inherit;
    }
    .HUD {
      grid-column: 1/2;
      grid-row: 2/3;
      margin-bottom: 0;
    }

    .penduWord {
      grid-column: 1/3;
      grid-row: 1/2;
    }

    #progressPendu {
      height: 10vw;
      width: 10vw;
      border-radius: 10vw;
      background-color: var(--goalBackgroundColor);
    }

    .progression {
      position: relative;
      display: flex;
      align-items: center;
      grid-column: 2/3;
      grid-row: 2/3;
    }
  }
</style>